import Vue from 'vue'
import Router from 'vue-router'

const CustomerDetails = () => import('@/views/customers/CustomerDetails')
const ThankYou = () => import('@/views/customers/ThankYou')

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes() {
  return [   
    {
      path: '/details/:customer_docid',
      name: 'CustomerDetails',
      component: CustomerDetails
    },
    {
      path: '/thankyou/:transactionID',
      name: 'ThankYou',
      component: ThankYou
    },
  ]
}

